import _get from 'lodash/get'

export const get_memberships = state => _get(state, 'memberships.memberships')
export const get_membership_list = state => _get(state, 'memberships.membershipList')
export const get_membership_items = state => _get(state, 'memberships.membershipItems')
export const get_visit_added = state => _get(state, 'memberships.visitAdded')
export const get_membership_visits = state => _get(state, 'memberships.membershipVisits')
export const get_visit_updated = state => _get(state, 'memberships.visitUpdated')
export const get_membership_data = state => _get(state, 'memberships.membershipData')
